var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg096Twitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_096-twitter",
    "data-name": "096-twitter",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.536,
    height: 24,
    viewBox: "0 0 29.536 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67390",
    "data-name": "Group 67390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67389",
    "data-name": "Group 67389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80456",
    "data-name": "Path 80456",
    d: "M26.5,53.954a12.088,12.088,0,0,0,3.035-3.143h0a12.646,12.646,0,0,1-3.489.956,6.023,6.023,0,0,0,2.664-3.346,12.116,12.116,0,0,1-3.84,1.466A6.054,6.054,0,0,0,14.4,54.026a6.235,6.235,0,0,0,.14,1.381A17.143,17.143,0,0,1,2.056,49.072a6.055,6.055,0,0,0,1.861,8.093,5.985,5.985,0,0,1-2.736-.746v.066a6.083,6.083,0,0,0,4.851,5.95,6.021,6.021,0,0,1-1.588.2,5.345,5.345,0,0,1-1.146-.1,6.115,6.115,0,0,0,5.657,4.219,12.171,12.171,0,0,1-7.508,2.582A11.454,11.454,0,0,1,0,69.25a17.052,17.052,0,0,0,9.289,2.717A17.116,17.116,0,0,0,26.5,53.954Z",
    transform: "translate(0 -47.968)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg096Twitter);
export default __webpack_public_path__ + "static/media/096-twitter.0e455a6356d57eb6b11c00b851eead8b.svg";
export { ForwardRef as ReactComponent };